import { SummativeTestProperties } from 'apps/web/enums/pageKey';
import { getLocalStorageItem } from 'apps/web/utils/helper';
import { parseJSON } from 'apps/web/utils/parseJson';

import { Language } from '@lessonPlanner/enums';

import FORM_KEYS from './formKeys';

const formDefaultValues = () => ({
  LocalSummativeTest: {
    [FORM_KEYS.format]: getLocalStorageItem(SummativeTestProperties.format),
    [FORM_KEYS.subject]: getLocalStorageItem(SummativeTestProperties.subject),
    [FORM_KEYS.gradeLevel]: getLocalStorageItem(
      SummativeTestProperties.gradeLevel,
    ),
    [FORM_KEYS.topics]: parseJSON(
      getLocalStorageItem(SummativeTestProperties.topics),
      [{ topic: '', subtopics: [''] }],
    ),
    [FORM_KEYS.language]: getLocalStorageItem(
      SummativeTestProperties.language,
      Language.ENGLISH,
    ),
  },
  InternationalSummativeTest: {
    [FORM_KEYS.curriculum]: getLocalStorageItem(
      SummativeTestProperties.curriculum,
    ),
    [FORM_KEYS.subject]: getLocalStorageItem(SummativeTestProperties.subject),
    [FORM_KEYS.gradeLevel]: getLocalStorageItem(
      SummativeTestProperties.gradeLevel,
    ),
    [FORM_KEYS.topics]: parseJSON(
      getLocalStorageItem(SummativeTestProperties.topics),
      [{ topic: '', subtopics: [''] }],
    ),
    [FORM_KEYS.language]: getLocalStorageItem(
      SummativeTestProperties.language,
      Language.ENGLISH,
    ),
    [FORM_KEYS.assessmentTypes]: parseJSON(
      getLocalStorageItem(SummativeTestProperties.assessmentTypes),
      [] as string[],
    ),
  },
  AmericanSummativeTest: {
    [FORM_KEYS.curriculumFramework]: getLocalStorageItem(
      SummativeTestProperties.curriculumFramework,
    ),
    [FORM_KEYS.subject]: getLocalStorageItem(SummativeTestProperties.subject),
    [FORM_KEYS.gradeLevel]: getLocalStorageItem(
      SummativeTestProperties.gradeLevel,
    ),
    [FORM_KEYS.specificStandard]: getLocalStorageItem(
      SummativeTestProperties.standard,
    ),
    [FORM_KEYS.topics]: parseJSON(
      getLocalStorageItem(SummativeTestProperties.topics),
      [{ topic: '', subtopics: [''] }],
    ),
    [FORM_KEYS.strategies]: getLocalStorageItem(
      SummativeTestProperties.strategies,
    ),
    [FORM_KEYS.language]: Language.ENGLISH,
  },
});

export default formDefaultValues;
